import * as React from 'react';
import { Provider } from 'react-redux';
import { getStore } from '../reducers';

// Сейчас у нас компоненты создаются изолированно, поэтому необходимо каждый
// раз оборачивать в Provider, в будущем эта проблема отпадет при отказе от ангуляра
/**
 * @deprecated Используй HOC attachReactComponent.
 */
export function withProvider<T extends object>(WrappedComponent: React.ComponentType<T>) {
  // eslint-disable-next-line react/display-name
  return (props: T) => {
    const store = getStore();

    return (
      <Provider store={store}>
        <WrappedComponent {...(props as T)} />
      </Provider>
    );
  };
}
